// Generated by purs version 0.15.0
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Restaumatic_PromotionsEngine_Cart_PromotionalItem from "../Restaumatic.PromotionsEngine.Cart.PromotionalItem/index.js";
import * as Restaumatic_PromotionsEngine_Common from "../Restaumatic.PromotionsEngine.Common/index.js";
import * as Restaumatic_PromotionsEngine_Tools_Distribution from "../Restaumatic.PromotionsEngine.Tools.Distribution/index.js";
import * as Restaumatic_PromotionsEngine_Tools_ProductAssignment from "../Restaumatic.PromotionsEngine.Tools.ProductAssignment/index.js";
import * as Restaumatic_PromotionsEngine_Tools_PromotionEvaluation from "../Restaumatic.PromotionsEngine.Tools.PromotionEvaluation/index.js";
var optimizationLimit = 10;
var calcAssignments = function (dictOrd) {
    return function (items) {
        var v = Restaumatic_PromotionsEngine_Common.partitionTuple(Restaumatic_PromotionsEngine_Cart_PromotionalItem.isTouchedByUser)(items);
        var v1 = Restaumatic_PromotionsEngine_Common.partitionTuple(Restaumatic_PromotionsEngine_Cart_PromotionalItem.isItemAutoAssigneable)(v.value1);
        var v2 = Restaumatic_PromotionsEngine_Common.partitionTuple(Restaumatic_PromotionsEngine_Cart_PromotionalItem.isEnabledByUser)(v.value0);
        var v3 = Restaumatic_PromotionsEngine_Common.partitionTuple(Restaumatic_PromotionsEngine_Cart_PromotionalItem.isCartPromotionalItem)(v2.value0);
        var v4 = Restaumatic_PromotionsEngine_Common.partitionTuple(Restaumatic_PromotionsEngine_Cart_PromotionalItem.isCartPromotionalItem)(v1.value0);
        var v5 = Restaumatic_PromotionsEngine_Common.partitionTuple(function (v6) {
            return Restaumatic_PromotionsEngine_Cart_PromotionalItem.canCombineWithAll(v6)(v2.value0);
        })(v4.value0);
        var autoAssignedCartItems = Data_Functor.map(Data_Functor.functorArray)(Restaumatic_PromotionsEngine_Cart_PromotionalItem.setAssignment(dictOrd)(Restaumatic_PromotionsEngine_Cart_PromotionalItem.mkAssignmentToCart))(Restaumatic_PromotionsEngine_Cart_PromotionalItem.combineableClique(v5.value0));
        var nonAssignedCartItems = Restaumatic_PromotionsEngine_Cart_PromotionalItem.excludeItemsFrom(autoAssignedCartItems)(v5.value0);
        var allAssignedCartItems = Data_Semigroup.append(Data_Semigroup.semigroupArray)(autoAssignedCartItems)(v3.value0);
        var v6 = Restaumatic_PromotionsEngine_Common.partitionTuple(function (v7) {
            return Restaumatic_PromotionsEngine_Cart_PromotionalItem.canCombineWithAll(v7)(allAssignedCartItems);
        })(v4.value1);
        var v7 = Restaumatic_PromotionsEngine_Common.splitAt(optimizationLimit)(v6.value0);
        var rejectedItems = Restaumatic_PromotionsEngine_Cart_PromotionalItem.resetPromotionalItems(dictOrd)(Data_Semigroup.append(Data_Semigroup.semigroupArray)(nonAssignedCartItems)(Data_Semigroup.append(Data_Semigroup.semigroupArray)(v5.value1)(Data_Semigroup.append(Data_Semigroup.semigroupArray)(v6.value1)(Data_Semigroup.append(Data_Semigroup.semigroupArray)(v7.value1)(v1.value1)))));
        var autoAssignedProductItems = Restaumatic_PromotionsEngine_Tools_ProductAssignment.promotionProductAssignment(dictOrd)(v2.value0)(v7.value0);
        var resultItems = Data_Semigroup.append(Data_Semigroup.semigroupArray)(autoAssignedCartItems)(Data_Semigroup.append(Data_Semigroup.semigroupArray)(autoAssignedProductItems)(Data_Semigroup.append(Data_Semigroup.semigroupArray)(rejectedItems)(v.value0)));
        return resultItems;
    };
};
var autoselectAssignedPromotionalItem = function (item) {
    var $39 = Restaumatic_PromotionsEngine_Cart_PromotionalItem.isTouchedByUser(item);
    if ($39) {
        return item;
    };
    var v = Restaumatic_PromotionsEngine_Cart_PromotionalItem.assignment(item);
    if (v instanceof Restaumatic_PromotionsEngine_Cart_PromotionalItem.AssignmentToCart) {
        return Restaumatic_PromotionsEngine_Cart_PromotionalItem.setSelection(Restaumatic_PromotionsEngine_Cart_PromotionalItem.AutoEnabled.value)(item);
    };
    if (v instanceof Restaumatic_PromotionsEngine_Cart_PromotionalItem.AssignmentToProduct) {
        return Restaumatic_PromotionsEngine_Cart_PromotionalItem.setSelection(Restaumatic_PromotionsEngine_Cart_PromotionalItem.AutoEnabled.value)(item);
    };
    return item;
};
var autoselectAssignedPromotionalItems = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray)(autoselectAssignedPromotionalItem);
var autoselectEvaluatePromotionalItems = function (dictEq) {
    return function (inputCartData) {
        var $42 = Restaumatic_PromotionsEngine_Tools_PromotionEvaluation.evaluateEnabledPromotionalItems(dictEq)(inputCartData);
        return function ($43) {
            return $42(autoselectAssignedPromotionalItems($43));
        };
    };
};
var assignPromotionalItems = function (dictOrd) {
    return function (inputCartData) {
        return function (items) {
            var resultItems = calcAssignments(dictOrd)(items);
            var evaluatedItems = autoselectEvaluatePromotionalItems(dictOrd.Eq0())(inputCartData)(resultItems);
            return Data_Array.sortWith(Data_Ord.ordInt)(Restaumatic_PromotionsEngine_Cart_PromotionalItem.promotionalItemId)(evaluatedItems);
        };
    };
};
var assignPromotions = function (dictOrd) {
    return function (inputCartData) {
        return function (promotions) {
            var promotionalItems = Restaumatic_PromotionsEngine_Tools_Distribution.distributePromotions(dictOrd)(inputCartData)(promotions);
            return assignPromotionalItems(dictOrd)(inputCartData)(promotionalItems);
        };
    };
};
var allCombineableTuple = function (promotionalItem) {
    return function (promotionalItems) {
        return new Data_Tuple.Tuple(promotionalItem, Restaumatic_PromotionsEngine_Cart_PromotionalItem.allCombineable(promotionalItem)(promotionalItems));
    };
};
export {
    assignPromotions,
    assignPromotionalItems
};
//# sourceMappingURL=index.js.map
